export const START_TIME = 60
export const PRACTICE_TIME = 999999
export const CLEAR_BONUS_TIME = 5
export const STAGE_BONUS_TIME = 15
export const STAGE_CLEAR_PER_BLOCK = 10

export function boardSizeForStage(stage: number, isLargeScreen: boolean): number {
  if (isLargeScreen) {
    if (stage <= 4) return 4
    if (stage <= 9) return 5
    if (stage <= 14) return 6
    if (stage <= 19) return 7
    if (stage <= 24) return 8
    if (stage <= 29) return 9
    return 10
  }
  if (stage <= 4) return 4
  if (stage <= 9) return 5
  if (stage <= 14) return 6
  if (stage <= 19) return 7
  return 8
}

export function timerSpeed(stage: number): number {
  const m = 1.0 - (stage - 1) * 0.1
  return Math.min(1.0, Math.max(0.5, m))
}

export function scoreForCount(n: number): number {
  switch (n) {
    case 2: return 100
    case 3: return 200
    case 4: return 350
    case 5: return 550
    default: return 100 + (n - 2) * 150
  }
}
